export const tag = 'm050c050footerpw';
export const load = async () => {
    const { M050C050FooterPwComponent } = await import('./m050-c050-footer-pw.component');
    return {
        component: M050C050FooterPwComponent,
    };
};
